for (var i = 0; i < 120; i++) {
  createGulal(i);
}

function createGulal(i) {
  var size = 40 + Math.random() * 90;
  var colorIdx = Math.ceil(Math.random() * 3);
  var colorClass = "gulal-red";

  switch (colorIdx) {
    case 1:
      colorClass = "gulal-yellow";
      break;
    case 2:
      colorClass = "gulal-blue";
      break;
    default:
      colorClass = "gulal-red";
  }

  $('<div class="gulal gulal-' + i + ' ' + colorClass + '"></div>').css({
    width: size + "px",
    height: size + "px",
    top: -Math.random() * 20 + "%",
    left: Math.random() * 100 + "%",
    opacity: 0.35 + Math.random() * 0.35
  }).appendTo(".wrapper");

  drift(i);
}

function drift(i) {
  $('.gulal-' + i).animate(
    {
      top: "110%",
      left: "+=" + (Math.random() * 20 - 10) + "%"
    },
    Math.random() * 6000 + 6000,
    "linear",
    function () {
      reset(i);
    }
  );
}

function reset(i) {
  $('.gulal-' + i).css({
    top: -Math.random() * 20 + "%",
    left: Math.random() * 100 + "%"
  });

  drift(i);
}
